import { render } from "./NotificationsChatbot.vue?vue&type=template&id=f0730986&scoped=true"
import script from "./NotificationsChatbot.vue?vue&type=script&lang=js"
export * from "./NotificationsChatbot.vue?vue&type=script&lang=js"

import "./NotificationsChatbot.vue?vue&type=style&index=0&id=f0730986&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0730986"]])

export default __exports__